import React from "react";
import banner from "../assets/school.jpg";
import "../styles/home.css";

export default function NamasteHero({ name }) {

  return (
    <section className="hero-section">

      <div
        className="hero-banner"
        style={{ backgroundImage: `url(${banner})` }}
      >

        <div className="hero-overlay">

          <h2 className="hero-welcome">
            WELCOME TO
          </h2>

          <h1 className="hero-title">
            {name}
          </h1>

          <p className="hero-tagline">
            Serving society with values and compassion
          </p>

        </div>

      </div>

    </section>
  );

}